export default {"src":"/app/_next/static/media/puzzle.47fe643c.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};